/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientSurvey from './patient-survey';
import PatientSurveyDetail from './patient-survey-detail';
import PatientSurveyUpdate from './patient-survey-update';
import PatientSurveyDeleteDialog from './patient-survey-delete-dialog';

const PatientSurveyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientSurvey />} />
    <Route path="new" element={<PatientSurveyUpdate />} />
    <Route path=":id">
      <Route index element={<PatientSurveyDetail />} />
      <Route path="edit" element={<PatientSurveyUpdate />} />
      <Route path="delete" element={<PatientSurveyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientSurveyRoutes;
